import { useTranslation } from 'react-i18next'

const Footer = () => {
  const { t } = useTranslation()

  return (
    <footer className="relative py-12 px-6 border-t border-crafter-accent/10">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col md:flex-row items-center justify-between gap-6">
          {/* Logo */}
          <div className="flex items-center gap-3">
            <div className="w-8 h-8 relative">
              <svg viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M16 4L28 10V22L16 28L4 22V10L16 4Z"
                  stroke="currentColor"
                  strokeWidth="1.5"
                  className="text-crafter-accent"
                />
                <circle cx="16" cy="16" r="4" className="fill-crafter-accent" />
              </svg>
            </div>
            <span className="font-sans font-semibold text-lg">{t('brandName')}</span>
          </div>

          {/* Links */}
          <div className="flex items-center gap-6">
            <a
              href="#features"
              className="font-mono text-sm text-crafter-textDim hover:text-crafter-accent transition-colors"
            >
              {t('nav.features')}
            </a>
            <a
              href="#interface"
              className="font-mono text-sm text-crafter-textDim hover:text-crafter-accent transition-colors"
            >
              {t('nav.interface')}
            </a>
          </div>

          {/* Copyright */}
          <div className="font-mono text-xs text-crafter-textDim">
            {t('footer.copyright')}
          </div>
        </div>
      </div>
    </footer>
  )
}

export default Footer
